"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFlexGridItem = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components/"));
var asg_1 = require("@alinta-digital/asg");
// for Navigation and MobileNavigation
exports.StyledFlexGridItem = (0, styled_components_1.default)(asg_1.FlexGridItem)(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  @media (min-width: 704px) {\n    max-width: 50%;\n  }\n"], ["\n  @media (min-width: 704px) {\n    max-width: 50%;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=Styles.js.map